import { Tab, Tabs, styled } from "@mui/material";
import { colours } from "../StyleConstants";


const LassoTabs = styled(Tabs)({
    '& .MuiTabs-indicator': {
        backgroundColor: colours.orange.orange,
        height: '4px',
    },
});

const LassoTab = styled(Tab)({
    borderBottom: '4px solid', borderColor: colours.gray.gray20,
});

export { LassoTab, LassoTabs };